import React from 'react';
import { useTranslation } from 'react-i18next';
import FastReading from '../components/reading/FastReading';
import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CustomMessage from '../components/Home/Custom Message';
import FastReadingCategory from '../components/reading/FastReadingCategory';
import OneCardFastReading from '../components/reading/OneCardFastReading';
import CardsMeaningWidget from '../components/Home/CardsMeaningWidget';

const Home: React.FC = () => {
  const theme = useTheme();
  const { t } = useTranslation();

  const HomeTitle = ({ title }: { title: string }) => {
    return (
      <Typography variant="h6" sx={{ mt: 2, mb: 1, color: theme.palette.background.dark, fontFamily: '"Playfair Display", serif' }}>
        {title}
      </Typography>
    )
  }

  return (
    <div className="justify-left items-start">
      <CustomMessage />
      <OneCardFastReading />
      <HomeTitle title={t('home.favoriteReadingTypes')} />
      <FastReadingCategory />
      <CardsMeaningWidget />
    </div>
  );
};

export default Home;
